module.exports = __webpack_public_path__ + "static/media/1@2x.cc5fc76d.png";